/**
 * ODIST 메뉴·페이지 키 정본 (2026-08-24)
 *
 * 한 파일이 세 군데를 먹인다 — App.vue odist 사이드바(menu_type 6), 역할(권한) 편집기, 라우터 가드.
 * 메뉴를 넣고 빼려면 여기만 고치면 된다. (erp 의 erp-menus.js 는 App.vue 와 이중관리라 어긋났었다)
 *
 *  - key       : 역할 permissions.pages 의 키. 한 번 정하면 바꾸지 말 것(저장된 역할이 그 키를 들고 있다)
 *  - scope     : 'master' | 'store' | 'both' — 어느 계정 종류의 메뉴에 나오는가
 *  - readonly  : 조회밖에 없는 화면 (역할 편집기에서 '수정' 칸이 없다)
 *  - masterOnly: scope 'both' 그룹 안에서 마스터에만 나오는 항목
 *  - alsoMaster: scope 'store' 그룹 안에서 마스터에도 나오는 항목(상품 이력 조회 — 마스터는 전체 통합만)
 *  - subOnly   : 서브계정(직원)에게만 보이고 마스터 본인에겐 숨김(바이오익스프레스 뷰). 역할이 그 키를 grant 해야 실제로 보인다
 *  - hidden    : 메뉴·역할 편집기 어디에도 안 나온다(운영자가 감춘 화면). 라우트와 key 매핑은 남겨 두므로
 *                직접 URL 은 종전 권한 그대로 열리고, 저장된 역할의 키도 깨지지 않는다. 되살리려면 이 줄만 지운다.
 *  - aliases   : 메뉴에는 없지만 같은 권한으로 열리는 라우트(상세/숨김 화면)
 *  - permOnly  : 화면이 아니라 **권한만**(역할 편집기에만 '없음/허용'으로 나온다, path 없음). 예: 발주 계획서 결재(2026-10-14)
 */
export const ODIST_MENUS = [
  {
    key: 'g_master_base', title: '거래처 발주품목 관리', scope: 'master',
    items: [
      { key: 'vendor_management',    title: '거래처 관리',          path: '/admin/odist/vendor_management' },
      { key: 'category_management',  title: '품목 분류 관리',       path: '/admin/odist/category_management' },
      { key: 'option_management',    title: '품목 옵션 관리',       path: '/admin/odist/option_management' },
      { key: 'item_list',            title: '품목 관리',            path: '/admin/odist/item_list', aliases: ['/admin/odist/item_register'] },
      { key: 'pack_map',             title: '박스 입수량 관리',     path: '/admin/odist/pack_map', aliases: ['/admin/odist/pack_convert'] },
      // 바코드 연결(2026-10-13) — 같은 상품의 다른 바코드. 저장은 박스와 같은 표(입수량 1)지만 화면은 따로다.
      // npos(POS 재고 차감)가 연결을 아는 버전이 2026-10-14 배포돼 열었다(그 전엔 hidden).
      { key: 'barcode_link',         title: '바코드 연결',          path: '/admin/odist/barcode_link' },
      // 택(2026-10-14, 미미라인) — 지점마다 품목에 쓰는 택. 입고 확인 창 줄마다 표시. 품목 지정은 엑셀 또는 품목 관리 [택 지정]
      { key: 'item_tag',             title: '택 관리',              path: '/admin/odist/item_tag' },
      { key: 'item_combo_register',  title: '상품 조합 등록',       path: '/admin/odist/item_combo_register' },
      { key: 'item_paste_register',  title: '상품 코드 붙여넣기 등록', path: '/admin/odist/item_paste_register' },
      { key: 'item_migrate_register', title: '외부 상품코드 이관 등록', path: '/admin/odist/item_migrate_register' },
      { key: 'item_attr_upload',     title: '품목 일괄 업데이트(엑셀)', path: '/admin/odist/item_attr_upload' },
      { key: 'item_image_upload',    title: '상품 이미지 등록',     path: '/admin/odist/item_image_upload' },
    ],
  },
  {
    key: 'g_master_settlement', title: '정산 관리', scope: 'master',
    items: [
      { key: 'settlement', title: '거래처별 정산', path: '/admin/odist/settlement' },
    ],
  },
  {
    key: 'g_store_search', title: '상품 조회', scope: 'store',
    items: [
      { key: 'store_item_search', title: '상품 조회',            path: '/admin/odist/store_item_search', readonly: true },
      // 상품 이력: 재고가 움직인 기록(입고·이동·판매·반품·조정·폐기)을 한 상품 기준으로. 매장 메뉴지만 마스터도 전체 통합으로 본다(alsoMaster).
      { key: 'item_history',      title: '상품 이력 조회',       path: '/admin/odist/item_history', readonly: true, alsoMaster: true },
      // 가격 변경이력(2026-09-29) — 매입단가·판매가를 따로. 매입단가 탭은 매입가 숨김 역할이면 안 보인다.
      { key: 'price_history',     title: '가격 변경이력',        path: '/admin/odist/price_history', readonly: true, alsoMaster: true },
      { key: 'item_block',        title: '입고/판매 금지 관리',  path: '/admin/odist/item_block' },
    ],
  },
  {
    key: 'g_store_location', title: '로케이션 관리', scope: 'store',
    // 🔑메뉴 순서 = **작업 순서**. 진열대를 먼저 만들어야 도면에 놓을 수 있다(운영자 2026-09-03).
    //   개념 계층(도면 > 진열대)으로 세웠다가, 실제로 손이 가는 순서가 반대라 바꿨다.
    items: [
      { key: 'location_shelf',          title: '진열대 관리',        path: '/admin/odist/location_shelf', aliases: ['/admin/odist/location_assign'] },
      { key: 'location_planogram',      title: '진열대 배치도 관리', path: '/admin/odist/location_planogram' },
      { key: 'location_planogram_view', title: '진열대 배치도 조회', path: '/admin/odist/location_planogram_view', readonly: true },
      // '매장 도면 조회'(location_floorplan_view)는 메뉴에서 뺐다 — 관리 화면으로 충분하다는 판단(운영자 2026-09-03).
      // 코드·라우트는 그대로 두고 alias 로만 연결해 직접 URL 로는 열린다(location_assign 을 숨긴 것과 같은 방식).
      { key: 'floor_plan',              title: '매장 도면',          path: '/admin/odist/location_floorplan',
        aliases: ['/admin/odist/location_floorplan_view'] },
    ],
  },
  {
    key: 'g_store_order', title: '발주 및 입고', scope: 'store',
    items: [
      // 도면에서 진열대를 골라 그 자리 상품을 발주. 로케이션 기능이지만 실제 업무는 '발주'라 이 그룹에 둔다.
      // 외부(제약사 자체 사이트 등) 발주용. 로케이션이 없는 매장은 이쪽이 유일한 발주계획 입구다.
      { key: 'order_plan',         title: '발주 계획',          path: '/admin/odist/order_plan' },
      { key: 'order_plan_list',    title: '발주 계획서',        path: '/admin/odist/order_plan_list' },
      // 결재(승인·반려) 권한 — 화면은 '발주 계획서'. 본계정·매장 계정은 늘 가능, 직원은 역할에서 '허용'해야 한다(서버 PATH_KEYS 같은 키).
      { key: 'order_plan_approve', title: '발주 계획서 결재',   permOnly: true },
      { key: 'location_order',     title: '로케이션 발주',      path: '/admin/odist/location_order' },
      { key: 'order',              title: '신규 발주',          path: '/admin/odist/order' },
      { key: 'order_list',         title: '발주 현황',          path: '/admin/odist/order_list', aliases: ['/admin/odist/order_detail'] },
      { key: 'confirm_order',      title: '입고 확인',          path: '/admin/odist/confirm_order' },
      { key: 'pre_receipt',        title: '사전 입고',          path: '/admin/odist/pre_receipt' },
      { key: 'pre_receipt_settle', title: '사전입고 단가/정산', path: '/admin/odist/pre_receipt_settle' },
      // 입고내역 조회(2026-09-28) — 입고 줄 전체 + 비고 + 계획서 미입고. 필터로 '수량 차이 있는 것만'. 마스터는 산하 매장 전체.
      { key: 'receipt_lines',      title: '입고내역 조회',      path: '/admin/odist/receipt_lines', readonly: true, alsoMaster: true },
      // 판촉물 관리(2026-10-22, 케뷰) — 입고 때 같이 온 판촉물을 글자로 기록·조회(품목 데이터와 연결 안 함). 마스터는 산하 매장 전체.
      { key: 'promo_goods',        title: '판촉물 관리',        path: '/admin/odist/promo_goods', alsoMaster: true },
    ],
  },
  {
    key: 'g_store_stock', title: '매장단위 재고관리', scope: 'store',
    items: [
      // 재고 현황: 매장 메뉴지만 마스터도 본다(alsoMaster). 케뷰는 창고로 발주해 매장으로 출고하는 구조라
      //   한 계정에서 매장을 골라 가며 보고 싶다는 요청(2026-09-10). 마스터는 화면에서 '전체 통합/매장'을 고른다.
      { key: 'stock_status',     title: '재고 현황(발주 계획)', path: '/admin/odist/stock_status', readonly: true, alsoMaster: true },
      { key: 'stock_transfer',   title: '재고 출고(매장간)',    path: '/admin/odist/stock_transfer' },
      { key: 'return',           title: '반품 관리',            path: '/admin/odist/return' },
      { key: 'inventory_adjust', title: '재고 조정',            path: '/admin/odist/inventory_adjust' },
      { key: 'disposal',         title: '폐기 관리',            path: '/admin/odist/disposal' },
      { key: 'stock_overwrite',  title: '재고 일괄 덮어쓰기',  path: '/admin/odist/stock_overwrite' },
    ],
  },
  {
    key: 'g_store_as', title: 'AS 관리', scope: 'store',
    items: [
      { key: 'as_request', title: 'AS 신청', path: '/admin/odist/as_request' },
      { key: 'as_receive', title: 'AS 입고', path: '/admin/odist/as_receive' },
    ],
  },
  {
    key: 'g_store_sales', title: '판매 관리', scope: 'store',
    items: [
      { key: 'set_product',        title: '세트상품 관리',      path: '/admin/odist/set_product' },
      { key: 'promotion',          title: '금액 할인 행사',     path: '/admin/odist/promotion' },
      { key: 'pos_sales_upload',   title: '타사 POS 판매 업로드', path: '/admin/odist/pos_sales_upload' },
      { key: 'pos_sales_analysis', title: '타사 POS 판매 분석', path: '/admin/odist/pos_sales_analysis', readonly: true },
    ],
  },
  {
    // 화면은 /admin/sales_report/* 와 같은 컴포넌트지만 odist 경로로 들어와야 샤드(npos-api)를 조회한다.
    key: 'g_report', title: '판매 리포트', scope: 'both',
    items: [
      { key: 'sr_summary',          title: '매출 집계',      path: '/admin/odist/sales_report/summary', readonly: true },
      { key: 'sr_summary_calendar', title: '매출 달력',      path: '/admin/odist/sales_report/summary_calendar', readonly: true },
      { key: 'sr_daily_sales',      title: '일간 매출',      path: '/admin/odist/sales_report/daily_sales', readonly: true },
      { key: 'sr_monthly_sales',    title: '월간 매출',      path: '/admin/odist/sales_report/monthly_sales', readonly: true },
      { key: 'sr_period_sales',     title: '기간 매출',      path: '/admin/odist/sales_report/period_sales', readonly: true },
      { key: 'sr_yearly_sales',     title: '연간 매출',      path: '/admin/odist/sales_report/yearly_sales', readonly: true },
      { key: 'sr_hourly_sales',     title: '시간대별 매출',  path: '/admin/odist/sales_report/hourly_sales', readonly: true },
      // 기간비교(2026-09-28) — 기준 기간 vs 비교 기간 시간대별(타사 '매출속보' 참고). npos 매장만(판매 시각이 있는 곳).
      { key: 'sr_sales_compare',    title: '기간비교',       path: '/admin/odist/sales_compare', readonly: true },
      // 매출분석(2026-09-29) — 매입·판매·원가·이익·D/C 를 분류별(대→중→소→상품) / 거래처별 / 상품별로(타사 '경영종합보고서 · 매출분석' 참고).
      { key: 'sr_sales_breakdown',  title: '매출분석',       path: '/admin/odist/sales_breakdown', readonly: true },
      { key: 'sr_sales_by_product', title: '상품별 매출',    path: '/admin/odist/sales_report/sales_by_product', readonly: true },
      // 세트는 자기 바코드로 팔리고 재고는 구성품에서 빠진다 — 상품별 매출에 섞여 있어 따로 보는 화면을 뒀다.
      { key: 'sr_set_sales',        title: '세트 판매 이력', path: '/admin/odist/set_sales', readonly: true },
      // 🔒2026-09-10 운영자 요청으로 감춤. 같은 성격의 '타사 POS 판매 분석'(g_store_sales)은 그대로 둔다.
      { key: 'sales_analysis',     title: 'POS 판매 분석',   path: '/admin/odist/sales_analysis', readonly: true, hidden: true },
      { key: 'sr_tax_refund',       title: '환급 내역',      path: '/admin/odist/sales_report/tax_refund', readonly: true },
      { key: 'sr_tax_refund_products', title: '환급 상품 분석', path: '/admin/odist/sales_report/tax_refund_products', readonly: true },
      { key: 'sr_branch_sales',     title: '지점별 매출',    path: '/admin/odist/sales_report/branch_sales', readonly: true, masterOnly: true },
      { key: 'sr_branch_sales2',    title: '지점별 매출2',   path: '/admin/odist/sales_report/branch_sales2', readonly: true, masterOnly: true },
    ],
  },
  {
    // 바이오익스프레스 위탁 뷰 — 케뷰 판매를 거래처=바이오익스프레스로 좁혀 실공급처(공급처1/2)별로. bioex 서브계정이 이 그룹만 본다.
    key: 'g_biox', title: '바이오익스프레스 뷰', scope: 'master',
    items: [
      { key: 'biox_sales_settle', title: '실공급처별 판매정산', path: '/admin/odist/biox_sales_settle', readonly: true, subOnly: true },
      { key: 'biox_orders', title: '발주서 뷰', path: '/admin/odist/biox_orders', readonly: true, subOnly: true },
      { key: 'biox_settlement', title: '정산서 뷰', path: '/admin/odist/biox_settlement', readonly: true, subOnly: true },
    ],
  },
]

/** 역할 옵션 (페이지와 무관한 표시 권한). 역할 편집기 하단에 스위치로 나온다 */
export const ODIST_ROLE_OPTIONS = [
  { key: 'show_purchase_price', title: '매입단가·원가 보기', desc: '끄면 매입단가/원가/마진이 화면·엑셀에서 가려집니다', default: true },
]

/** 마스터만 쓰는 관리 화면 — 역할 대상이 아니고 서브계정은 절대 못 들어간다 */
export const ODIST_MASTER_ADMIN_PATHS = ['/admin/odist/sub_account', '/admin/odist/role_management']

export const ODIST_LOGIN_PATH = '/odist/login'

const _byKey = {}
const _byPath = {}
ODIST_MENUS.forEach(g => g.items.forEach(it => {
  _byKey[it.key] = { ...it, group: g }
  if (it.path) _byPath[it.path] = _byKey[it.key]
  ;(it.aliases || []).forEach(a => { _byPath[a] = _byKey[it.key] })
}))

export const ODIST_PAGE_KEYS = Object.keys(_byKey)

export function odistMenuItem(key) {
  return _byKey[key] || null
}

/** 경로 → 메뉴 항목. 쿼리 제거, 정확일치 우선, 그다음 접두(/xxx/...) */
export function odistMenuItemByPath(fullPath) {
  const p = String(fullPath || '').split('?')[0].replace(/\/+$/, '')
  if (_byPath[p]) return _byPath[p]
  let best = null
  Object.keys(_byPath).forEach(k => {
    if (p.startsWith(k + '/') && (!best || k.length > best.length)) best = k
  })
  return best ? _byPath[best] : null
}

/** 어떤 계정 종류(마스터/매장)에서 보이는 항목인가 */
export function odistItemVisibleFor(item, isMaster) {
  if (item.hidden) return false          // 감춘 화면 — 사이드바·랜딩 후보 어디에도 안 나온다
  if (item.permOnly) return false        // 권한만 있는 항목 — 화면이 없다
  const scope = item.group ? item.group.scope : 'both'
  if (scope === 'master') return !!isMaster
  if (scope === 'store') return !isMaster || !!item.alsoMaster   // alsoMaster: 매장 그룹 항목이지만 마스터 사이드바에도 나온다
  if (item.masterOnly) return !!isMaster
  return true
}

/** 페이지 키 → 레벨 객체 헬퍼 (역할 편집기·프리셋용) */
function pages(level, filter) {
  const out = {}
  ODIST_MENUS.forEach(g => g.items.forEach(it => {
    if (it.hidden) return                // 감춘 화면은 기본 역할에도 넣지 않는다
    if (filter && !filter(it, g)) return
    out[it.key] = (level === 'write' && it.readonly) ? 'read' : level
  }))
  return out
}

/**
 * 기본 역할 5개. 역할이 하나도 없는 마스터가 처음 들어오면 이 정의를 그대로 만들어 준다.
 * 만든 뒤엔 마스터가 화면에서 마음대로 고친다 — 여기 정의는 '시작값'일 뿐이다.
 */
export const ODIST_ROLE_PRESETS = [
  {
    name: '매장 매니저', sort_order: 1,
    description: '매장 화면 전부 수정 가능',
    permissions: { pages: pages('write', (it, g) => g.scope !== 'master'), options: { show_purchase_price: true } },
  },
  {
    name: '매장 직원', sort_order: 2,
    description: '매장 조회 전부 + 발주/입고/사전입고만 수정. 재고조정·폐기·정산은 못 함',
    permissions: {
      pages: Object.assign(
        pages('read', (it, g) => g.scope !== 'master'),
        pages('write', (it, g) => ['order', 'order_list', 'confirm_order', 'pre_receipt', 'store_item_search',
                                   'location_shelf', 'location_planogram', 'location_order', 'floor_plan',
                                   'order_plan', 'order_plan_list', 'promo_goods'].includes(it.key)),
      ),
      options: { show_purchase_price: false },
    },
  },
  {
    name: '본사 MD', sort_order: 3,
    description: '마스터 기준정보(거래처·품목·분류·옵션·이미지) 수정 + 정산 조회 + 매장 화면 조회',
    permissions: {
      pages: Object.assign(
        pages('read'),
        pages('write', (it, g) => g.key === 'g_master_base'),
      ),
      options: { show_purchase_price: true },
    },
  },
  {
    name: '정산 담당', sort_order: 4,
    description: '마스터 정산 수정 + 나머지는 조회',
    permissions: {
      pages: Object.assign(pages('read'), pages('write', it => ['settlement', 'pre_receipt_settle'].includes(it.key))),
      options: { show_purchase_price: true },
    },
  },
  {
    name: '조회 전용', sort_order: 5,
    description: '모든 화면 조회만',
    permissions: { pages: pages('read'), options: { show_purchase_price: false } },
  },
]
